// src/pages/CertificatesPage.js
import React, { useState } from 'react';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import './CertificatesPage.css'; // This CSS will now match Media.css styling

// Helper function to import all images from a context
const importAll = (r) => {
  return r.keys().map(r);
};

// Make sure your certificates are in this folder: src/assets/certificates/
const certificateImages = importAll(require.context('../assets/certificates/', false, /\.jpe?g$|\.png$/i));


function CertificatesPage() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  // No separate loading state needed if images are directly imported like in Media.js
  // You might want to add a loading state if 'certificateImages' could be empty initially
  // but for static assets loaded with require.context, they are usually available sync.

  return (
    <div className="certificates-page"> {/* Changed class to match Media.js structure */}

      {/* --- Hero Section --- */}
      <section className="certificates-hero-section"> {/* New hero section */}
        <h1 className="certificates-hero-heading">Our Certifications & Recognition</h1>
        <p className="certificates-hero-subheading">
          Validating our commitment to excellence and quality.
        </p>
      </section>

      <div className="container"> {/* New container div */}
        {/* --- Certificates Gallery Section --- */}
        <section className="certificate-gallery-section"> {/* New section for the grid */}
          <h2 className="certificates-section-title">Certifications & Awards</h2>
          <p className="certificates-intro-text">
            Explore the prestigious certifications and awards that recognize Vishwambhara Shikshan Sanstha's dedication to our mission and impact. These accolades reflect our continuous pursuit of quality and commitment to the community. Click on any certificate to view in detail.
          </p>
          <div className="certificates-grid">
            {certificateImages.length > 0 ? (
              certificateImages.map((imageSrc, index) => ( // imageSrc is now directly the image path
                <div
                  className="certificate-item"
                  key={index}
                  onClick={() => openLightbox(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={imageSrc}
                    alt={`Certificate ${index + 1}`} // Generic, descriptive alt text
                    className="certificate-image"
                    loading="lazy"
                  />
                  {/* Optional: Add an overlay on hover if you want to show "View Certificate" */}
                  {/* <div className="certificate-overlay">
                    <span className="certificate-caption">View Certificate {index + 1}</span>
                  </div> */}
                </div>
              ))
            ) : (
              <p className="no-certificates-message">No certificates available yet. Please check back soon!</p>
            )}
          </div>

          {/* --- Lightbox Component --- */}
          {isOpen && (
            <Lightbox
              mainSrc={certificateImages[photoIndex]} // Directly use the image path
              nextSrc={certificateImages[(photoIndex + 1) % certificateImages.length]}
              prevSrc={certificateImages[(photoIndex + certificateImages.length - 1) % certificateImages.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + certificateImages.length - 1) % certificateImages.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % certificateImages.length)
              }
              imageTitle={`Certificate ${photoIndex + 1}`} // Generic title for lightbox
            />
          )}
        </section>

      </div> {/* End .container */}
    </div>
  );
}

export default CertificatesPage;